import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { PATHS } from "../../common/constants";
import Anchor from "../../components/Anchor";
import Auth from "../../layouts/Auth";
import { signIn } from "../../store/actions/auth";
import Button from "../../components/Button";
import Input from "../../components/Input";
import Loader from "../../components/Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import Icon from "../../components/Icon";
import Overlay from "../../components/Overlay";
import { Terms } from "./Terms";
import Checkbox from "../../components/Checkbox";
import Label from "../../components/Label";

import { Images } from "../../Tenants";
import { stopLoaders } from "../../store/actions/loader";

import pkg from '../../../package.json';

const validEmailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

class SiginIn extends React.Component {
  state = {
    email: "",
    password: "",
    termsAndConditions:
      localStorage.getItem("checked") === "checked" ? true : false,
    termsPopup: false,
    errors: [],
    newEmail: false,
    checkOnce: false,
  };

  async componentDidMount() {
    this.props.stopLoaders();

    const { href } = window.location;
    if (href.indexOf("sign-in") > -1) {
      window.history.pushState(null, null, "");
      window.addEventListener("popstate", function (event) {
        window.history.pushState(null, null, "");
      });
    }
  }

  validateFeilds() {
    const { email, password, termsAndConditions } = this.state;
    let errors = {};
    errors.email = "";
    errors.password = "";
    errors.termsAndConditions = "";
    if (email.trim().length > 0) {
      errors.emailValid = false;
    } else {
      errors.emailValid = true;
    }
    if (validEmailRegex.test(email.toLowerCase())) {
      errors.emailValidation = false;
    } else {
      errors.emailValidation = true;
    }
    if (password.length > 0) {
      errors.passwordValid = false;
    } else {
      errors.passwordValid = true;
    }
    if (password.length < 6) {
      errors.passwordValidation = true;
    } else {
      errors.passwordValidation = false;
    }

    termsAndConditions
      ? (errors.termsValidation = false)
      : (errors.termsValidation = true);

    if (errors.emailValid || errors.emailValidation) {
      errors.email = "Please enter a valid email address";
    }
    if (errors.passwordValid || errors.passwordValidation) {
      errors.password = "Password must be of 6 character !";
    }
    if (errors.termsValidation) {
      errors.termsAndConditions = "Please accept Terms of Use";
    }
    this.setState({ errors });

    let isValid = !Object.values(errors).includes(true);
    return isValid;
  }
  requestSignIn = () => {
    this.signIn(this.state.fcmToken);
  };
  signIn(fcmToken) {
    let validData = this.validateFeilds(this.state);
    if (validData) {
      document.cookie = "tremChecked=true";
      let data = {
        Username: this.state.email.trim(),
        Password: this.state.password,
        TokenKey: fcmToken,
      };

      let history = this.props.history;
      this.props.signIn(data, history);
    }
  }

  render() {
    return (
      <Auth
        title="Sign In"
        backgroundImage={Images.signInImage}
        content={
          <>
            {this.props.loader ? <Loader center={true} /> : null}
            <div className="sign-in">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.requestSignIn();
                }}
              >
                <div className="sign-in__header">
                  <div className="sign-in__headline">
                    Log in to your dashboard
                  </div>
                </div>
                <Input
                  value={this.state.email}
                  onChange={(e) =>
                    this.setState({ email: e.target.value, checkOnce: false })
                  }
                  label="Email Address"
                  placeholder="eg., example@address.com"
                  required
                  block
                  errors={this.state.errors.email}
                  data-cy="login-email"
                />
                <Input
                  value={this.state.password}
                  onChange={(e) =>
                    this.setState({
                      password: e.target.value,
                      checkOnce: false,
                    })
                  }
                  label="Password"
                  required
                  mask
                  block
                  errors={this.state.errors.password}
                  data-cy="login-password" 
                />
                <div>
                  <Checkbox
                    label=""
                    value={this.state.termsAndConditions}
                    onChange={() =>
                      this.setState({
                        termsAndConditions: !this.state.termsAndConditions,
                      })
                    }
                    data-cy="login-terms"
                  />
                  <a style={{ paddingLeft: 20 }} className="input__label">
                    <span>
                      I accept the{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({ termsPopup: !this.state.termsPopup })
                        }
                      >
                        Terms of Use
                      </span>
                    </span>
                  </a>

                  <p
                    className="input__error"
                    style={{ margin: "0rem 0 3rem 0" }}
                  >
                    {this.state.errors.termsAndConditions}
                  </p>
                </div>
                <div className="sign-in__forgotPassword">
                  <Anchor
                    path={PATHS.AUTH_FORGOT_PASSWORD}
                    label="Forgot password?"
                  />
                </div>
                <div className="sign-in__button">
                  <Button label="Sign In" color="teal" submit block data-cy="login-submit"/>
                </div>
                <div style={{ textAlign: "right" }}>
                  <Label color="teal" label={`Version: ${pkg.version}`} />
                </div>
                <Overlay
                  style={{ width: "auto" }}
                  showOverlay={this.state.termsPopup}
                  content={
                    <div
                      style={{
                        width: "auto",
                        padding: "10rem",
                        backgroundColor: "white",
                      }}
                    >
                      <div style={{ padding: "10px" }}>
                        <button
                          type="button"
                          className="form__dismiss"
                          style={{ color: "#454F5B" }}
                          onClick={() =>
                            this.setState({
                              termsPopup: !this.state.termsPopup,
                            })
                          }
                        >
                          <Icon weight="light" glyph="arrow-left" />
                        </button>

                        <span
                          className="heading-with-details__headline"
                          style={{ padding: "0px 50px" }}
                        >
                          Terms of Use
                        </span>
                      </div>
                      <div>
                        {
                          <div>
                            <Terms />
                            <div>&nbsp;</div>
                          </div>
                        }
                        <div style={{ textAlign: "center" }}>
                          <Button
                            label="Accept"
                            onClick={() =>
                              this.setState({
                                termsAndConditions: true,
                                termsPopup: !this.state.termsPopup,
                              })
                            }
                            size={"small"}
                          />
                        </div>
                      </div>
                    </div>
                  }
                ></Overlay>
              </form>
            </div>
          </>
        }
      />
    );
    // : null;
  }
}

const mapStateToProps = (state) => {
  return {
    loader: selectFormLoader(state),
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signIn: signIn,
      stopLoaders,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SiginIn);
